import React, { useState } from 'react';
import { signIn } from '../../services/auth';

const AdminLogin = ({ onLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL;
    const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        // First check if it's the admin email
        if (email !== ADMIN_EMAIL) {
            setError('Invalid admin credentials');
            setLoading(false);
            return;
        }

        // Try to sign in with Firebase
        const result = await signIn(email, password);
        
        if (result.success) {
            onLogin(true);
        } else {
            // Show user-friendly error message
            if (result.error.includes('invalid-credential') || result.error.includes('wrong-password')) {
                setError('Invalid email or password');
            } else if (result.error.includes('too-many-requests')) {
                setError('Too many failed attempts. Please try again later');
            } else {
                setError('Login failed. Please try again');
            }
        }
        setLoading(false);
    };

    return (
        <div className="min-h-[60vh] flex items-center justify-center">
            <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full">
                <div className="text-center mb-6">
                    <div className="w-20 h-20 bg-gradient-to-r from-gradpath-green to-gradpath-dark rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="fas fa-lock text-white text-3xl"></i>
                    </div>
                    <h2 className="text-2xl font-bold text-gradpath-dark">Admin Login</h2>
                    <p className="text-gray-500 text-sm">Enter your credentials to access the dashboard</p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Admin Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                            required
                        />
                    </div>
                    
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                            required
                        />
                    </div>

                    {error && (
                        <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg text-sm">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-gradient-to-r from-gradpath-green to-gradpath-dark text-white font-semibold py-3 rounded-lg hover:shadow-lg transition-all disabled:opacity-50"
                    >
                        {loading ? <i className="fas fa-spinner fa-spin"></i> : <><i className="fas fa-sign-in-alt mr-2"></i> Login</>}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;